import { applyMiddleware, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './rootReducer';

const composeEnhancers = typeof window === 'object' && compose;

const enhancer = composeEnhancers(applyMiddleware(thunk));

const store = createStore(rootReducer(), enhancer);

export default store;
